import { useRouter } from 'next/router';

import { Background } from '../Background';
import { Button, ButtonType, TextIconColor, Typography } from '../core';
import { TypographySize } from '../core/Typography';

// https://github.com/bvaughn/react-error-boundary
const ErrorScreen: React.FC = () => {
  const router = useRouter();

  return (
    <div
      className="flex h-screen w-screen flex-col items-center justify-center gap-6 p-10 text-center"
      data-testid="error-screen-container"
    >
      <Background />
      <div
        className="flex flex-col items-center justify-center gap-2"
        data-testid="error-screen-text-container"
      >
        <Typography color={TextIconColor.PRIMARY} size={TypographySize.H1}>
          Uh Oh
        </Typography>
        <div>
          <Typography color={TextIconColor.PRIMARY} size={TypographySize.H2}>
            Something went wrong.
          </Typography>
        </div>
      </div>
      <Button
        label="Return to home screen"
        onClick={() => {
          void router.replace('/');
        }}
        type={ButtonType.SOLID}
      />
    </div>
  );
};

export default ErrorScreen;
